import useIssueTypes from 'common/fetchHooks/pmProvider/useIssueTypes';
import {
  generateTableTypeFromIssueType,
  PROGRESSION_TABLE_TYPES
} from './progression-table-types';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import useIsTreeHierarchyEnabled from '../../../../state/filters/hooks/useIsTreeHierarchyEnabled';
import { ProjectProgressionFiltersContext } from '../../../../state/filters/contexts';
import { useMemo } from 'react';

const useTableTypes = () => {
  const pmProvider = useSelector(pmToolSensorIdSelector);
  const isTreeHierarchyEnabled = useIsTreeHierarchyEnabled(
    ProjectProgressionFiltersContext
  );

  const { issueTypes, isLoading } = useIssueTypes({
    enabled: isTreeHierarchyEnabled
  });

  const oldTableTypes = PROGRESSION_TABLE_TYPES[pmProvider];
  const issuesTableType = useMemo(() => oldTableTypes.ISSUES, [oldTableTypes]);

  const issueTypesTableTypes = useMemo(() => {
    const dynamicTableTypes = issueTypes?.reduce(
      (acc, issueType) => ({
        ...acc,
        [issueType?.issue_type]: generateTableTypeFromIssueType(
          issueType?.issue_type
        )
      }),
      {
        [issuesTableType.key]: issuesTableType
      }
    );

    return dynamicTableTypes;
  }, [issueTypes, issuesTableType]);

  const tableTypes = isTreeHierarchyEnabled
    ? issueTypesTableTypes
    : oldTableTypes;

  return {
    tableTypes,
    isLoading
  };
};

export default useTableTypes;
